<aix-percentage
    [config]="config"
    [isStandalone]="false"
    [isRequired]="templateData.fieldIsRequired"
    [isDisabled]="templateData.fieldIsDisabled"
    [isDirty]="templateData.fieldIsDirty"
    [isValid]="!templateData.ctrlIsInvalid"
    [aixDynamicNextPendingField]="{ config: config }"
    [initialValue]="value"
    [hint]="config?.hint ?? ''"
    (setDirty)="setDirty()"
    (valueChanges)="valueChange($event)"
>
    {{ config.label }}
</aix-percentage>

@if (templateData.canDisplayErrors) {
<div class="form-error--container ph-unmask">
    <div class="form-error" [data-testing]="config.refId! + '_validation_error'">
        {{ templateData.ctrlErrors | aixFormErrors : config.label }}
    </div>
</div>
}
